module.exports = __webpack_public_path__ + "img/discadorBlack.d7d9a416.gif";